import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Capítulos de aprendizaje y reportes de los usuarios (Envío AP-1). */
export const learningService = {
  async get() {
    const res = await axios.get(`${API}/learning`);
    return res.data;
  },
  async saveState(patch) {
    const res = await axios.post(`${API}/learning/state`, patch);
    return res.data;
  },
  async sendFeedback({ kind, message, context }) {
    const res = await axios.post(`${API}/feedback`, { kind, message, context });
    return res.data;
  },

  // ── admin ──
  async adminList() {
    const res = await axios.get(`${API}/admin/learning/chapters`);
    return res.data;
  },
  async adminCreate(values) {
    const res = await axios.post(`${API}/admin/learning/chapters`, values);
    return res.data;
  },
  async adminUpdate(id, values) {
    const res = await axios.patch(`${API}/admin/learning/chapters/${id}`, values);
    return res.data;
  },
  async adminDelete(id) {
    const res = await axios.delete(`${API}/admin/learning/chapters/${id}`);
    return res.data;
  },
  async adminReorder(ids) {
    const res = await axios.post(`${API}/admin/learning/reorder`, { ids });
    return res.data;
  },
  async adminFeedback({ status, kind } = {}) {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (kind) params.append('kind', kind);
    const res = await axios.get(`${API}/admin/feedback?${params}`);
    return res.data;
  },
  async adminUpdateFeedback(id, patch) {
    const res = await axios.patch(`${API}/admin/feedback/${id}`, patch);
    return res.data;
  },
};

export default learningService;
